module.exports = __webpack_public_path__ + "static/media/pie.4b77bc3d.jpg";